
window.debugMode =
  window.location.href.indexOf('debug-css=1') > -1

if (window.debugMode) {
  $('html').addClass('debug-css')
}
